import Backbone from 'backbone';
import Question from 'ef/models/question';

const Questions = Backbone.Collection.extend({
  model: Question,
});

export default Questions;
